<ng-container>
  <input
    #userSearch
    matInput
    type="search"
    class="search-input"
    *ngIf="!searchBoxHidden"
    autofocus
    (blur)="blurSearchFocus()"
    (input)="onSearchQueryChange($event.target.value)"
    [matAutocomplete]="auto"
    appAutocompletePosition
  />

  <mat-autocomplete class="dropdown" #auto="matAutocomplete">
    <div class="options-list">
      <mat-option
        *ngFor="let item of filteredOptions | async; let i = index"
        class="option-item"
        (mousedown)="selectItem(item)"
        [value]="item[valuePropName]"
      >
        <span
          class="option-label"
          [innerHTML]="item[valuePropName] | highlighter: searchInput?.nativeElement.value || ''"
        ></span>
      </mat-option>
    </div>

    <ng-container *ngIf="hasEditOption">
      <div class="divider"></div>
      <div class="button-container">
        <app-pencil-button
          class="pencil-button white small edit-options-btn"
          icon="edit"
          [iconConfig]="{ type: IconTypes.matIcon }"
          [label]="'Edit options' | translate"
          (clickEvent)="emitEditOption()"
        ></app-pencil-button>
      </div>
    </ng-container>
  </mat-autocomplete>
</ng-container>
